<template>
    <Button icon="pi pi-info-circle" size="small" variant="text" rounded
        :aria-label="t('settings.users.roles_info.title')" @click="showModal = true" />
    <RoleInfoModal v-model:visible="showModal" />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import Button from 'primevue/button'
import RoleInfoModal from './RoleInfoModal.vue'

const { t } = useI18n()
const showModal = ref(false)
</script>

<style scoped></style>

